var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading2 } from "@stellar/design-system";
import { BUSINESS_SERVER_ENDPOINT } from "App";
import { isUsdt0Code } from "const";
import { fetchTransaction } from "helpers/fetchTransaction";
import { readSep24Callbacks, storeSep24Callbacks, } from "helpers/sep24Callbacks";
import { getPaymentStatusChannel, usePaymentStatusPusher, } from "hooks/useDepositStatusPusher";
import { FALLBACK_POLL_MS, usePolling } from "hooks/usePolling";
import { capture } from "lib/analytics";
import { ROZO_EVENTS } from "lib/analytics/events";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAmountInAsset, getAmountOutAsset, getDepositTokenCode, } from "types";
var END_STATUS = [
    "completed",
    "error",
    "expired",
];
var BOOTSTRAP_STEP_PROGRESS = {
    "checking-transaction": 33,
    "starting-kyc-session": 66,
    "redirecting-to-kyc": 100,
};
var BOOTSTRAP_STEP_LABEL = {
    "checking-transaction": "Checking transaction status",
    "starting-kyc-session": "Starting KYC session",
    "redirecting-to-kyc": "Redirecting to KYC",
};
export function TxnInfoShell(_a) {
    var _this = this;
    var txnId = _a.txnId, token = _a.token, onTxnInfoUpdate = _a.onTxnInfoUpdate, children = _a.children;
    var searchParams = useSearchParams()[0];
    var onChangeCallback = searchParams.get("on_change_callback");
    var callbackQuery = searchParams.get("callback");
    var _b = useState(null), info = _b[0], setInfo = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(false), shouldStopPolling = _d[0], setShouldStopPolling = _d[1];
    var _e = useState("checking-transaction"), bootstrapStep = _e[0], setBootstrapStep = _e[1];
    var kycBootstrapStartedRef = useRef(false);
    var latestInfoRef = useRef(null);
    var updateInfo = function (tx) {
        var _a;
        if (JSON.stringify(latestInfoRef.current) === JSON.stringify(tx)) {
            if (error)
                setError(null);
            return;
        }
        var statusChanged = ((_a = latestInfoRef.current) === null || _a === void 0 ? void 0 : _a.status) !== tx.status;
        latestInfoRef.current = tx;
        setInfo(tx);
        if (statusChanged)
            onTxnInfoUpdate === null || onTxnInfoUpdate === void 0 ? void 0 : onTxnInfoUpdate(tx);
        setError(null);
    };
    var navigate = useNavigate();
    var pusherChannelName = getPaymentStatusChannel(info);
    var isUsdt0Transfer = Boolean(info &&
        (isUsdt0Code(getDepositTokenCode(info)) ||
            isUsdt0Code(getAmountInAsset(info)) ||
            isUsdt0Code(getAmountOutAsset(info))));
    usePaymentStatusPusher({
        channelName: pusherChannelName,
        logPrefix: (info === null || info === void 0 ? void 0 : info.kind) === "withdrawal" ? "[withdraw:pusher]" : "[deposit:pusher]",
        onAny: function (e) { return __awaiter(_this, void 0, void 0, function () {
            var txnResponse, tx, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log("pusher event", e);
                        // Always refresh from backend for the latest canonical state.
                        if (!token)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchTransaction(token)];
                    case 2:
                        txnResponse = _b.sent();
                        tx = txnResponse === null || txnResponse === void 0 ? void 0 : txnResponse.transaction;
                        if (tx) {
                            updateInfo(tx);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); },
    });
    useEffect(function () {
        if (!token && txnId) {
            setError("Missing authentication token. Please use the link provided by the wallet.");
        }
    }, [token, txnId]);
    var startKycFlow = function (authToken, prefetchedTransaction) { return __awaiter(_this, void 0, void 0, function () {
        var _a, storedCallback, storedOnChange, effectiveCallback, effectiveOnChangeCallback, requestBody, response, sessionId, kycParams, e_1, message;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    setBootstrapStep("starting-kyc-session");
                    _a = readSep24Callbacks({
                        transactionId: prefetchedTransaction.id,
                        authToken: authToken,
                    }), storedCallback = _a.callback, storedOnChange = _a.onChangeCallback;
                    effectiveCallback = (_b = callbackQuery !== null && callbackQuery !== void 0 ? callbackQuery : storedCallback) !== null && _b !== void 0 ? _b : null;
                    effectiveOnChangeCallback = onChangeCallback !== null && onChangeCallback !== void 0 ? onChangeCallback : storedOnChange;
                    requestBody = {};
                    // SEP-24: callback can be the literal "postMessage" — that's handled
                    // by the FE via window.postMessage and must NOT be forwarded to backend.
                    if (effectiveOnChangeCallback &&
                        effectiveOnChangeCallback !== "postMessage") {
                        requestBody.on_change_callback = effectiveOnChangeCallback;
                    }
                    return [4 /*yield*/, fetch("".concat(BUSINESS_SERVER_ENDPOINT, "/start"), {
                            method: "POST",
                            headers: {
                                Authorization: "Bearer ".concat(authToken),
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestBody),
                        })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Failed to start KYC flow");
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    sessionId = (_c.sent()).sessionId;
                    storeSep24Callbacks({
                        transactionId: prefetchedTransaction.id,
                        sessionToken: String(sessionId),
                        authToken: authToken,
                    }, {
                        callback: effectiveCallback !== null && effectiveCallback !== void 0 ? effectiveCallback : undefined,
                        onChangeCallback: effectiveOnChangeCallback !== null && effectiveOnChangeCallback !== void 0 ? effectiveOnChangeCallback : undefined,
                    });
                    kycParams = new URLSearchParams();
                    kycParams.set("session_token", String(sessionId));
                    if (effectiveCallback) {
                        kycParams.set("callback", effectiveCallback);
                    }
                    setBootstrapStep("redirecting-to-kyc");
                    capture(ROZO_EVENTS.KYC_BOOTSTRAP_REDIRECT, {
                        transaction_kind: prefetchedTransaction.kind,
                        transaction_id: prefetchedTransaction.id,
                    });
                    navigate({
                        pathname: "/kyc",
                        search: "?".concat(kycParams.toString()),
                    }, {
                        // Pass known transaction snapshot to avoid a redundant fetch in root.
                        state: { prefetchedTransaction: prefetchedTransaction },
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    message = e_1 instanceof Error ? e_1.message : "Failed to start KYC flow";
                    throw new Error(message);
                case 4: return [2 /*return*/];
            }
        });
    }); };
    usePolling({
        pollFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var txnResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!token)
                            return [2 /*return*/, undefined];
                        return [4 /*yield*/, fetchTransaction(token)];
                    case 1:
                        txnResponse = _a.sent();
                        return [2 /*return*/, txnResponse === null || txnResponse === void 0 ? void 0 : txnResponse.transaction];
                }
            });
        }); },
        shouldStop: function (transaction) { return END_STATUS.includes(transaction.status); },
        // With a Pusher channel the poll is only a fallback, and each poll makes
        // the backend query Rozo, so slow it down; before that, poll fast.
        interval: pusherChannelName ? FALLBACK_POLL_MS : 2000,
        // Withdrawals and per-order USDT0 transfers keep polling as fallback if
        // Pusher misses an update; otherwise the page stays on its last status.
        enabled: !!token &&
            !shouldStopPolling &&
            (!pusherChannelName ||
                (((info === null || info === void 0 ? void 0 : info.kind) === "withdrawal" || isUsdt0Transfer) &&
                    !!info &&
                    !END_STATUS.includes(info.status))),
        immediate: true,
        onData: function (transaction) { return __awaiter(_this, void 0, void 0, function () {
            var e_2, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!transaction)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!(transaction.status === "incomplete")) return [3 /*break*/, 4];
                        if (kycBootstrapStartedRef.current) {
                            return [2 /*return*/];
                        }
                        kycBootstrapStartedRef.current = true;
                        setShouldStopPolling(true);
                        if (!token) return [3 /*break*/, 3];
                        return [4 /*yield*/, startKycFlow(token, transaction)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                    case 4:
                        updateInfo(transaction);
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _a.sent();
                        kycBootstrapStartedRef.current = false;
                        message = e_2 instanceof Error ? e_2.message : "Failed to process transaction";
                        setError(message);
                        capture(ROZO_EVENTS.ERROR_OCCURRED, {
                            error_context: "txn_info_shell_kyc_bootstrap",
                            error_message: message,
                        });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); },
        onError: function (err) {
            var message = err.message || "Failed to load transaction";
            setError(message);
            capture(ROZO_EVENTS.ERROR_OCCURRED, {
                error_context: "txn_info_shell_polling",
                error_message: message,
            });
        },
    });
    if (error) {
        return (_jsxs("div", { className: "PageTransition", children: [_jsx(Heading2, { className: "TxnInfo__heading", children: "Error" }), _jsx("p", { children: error })] }));
    }
    if (!info) {
        var progressValue = BOOTSTRAP_STEP_PROGRESS[bootstrapStep];
        var progressLabel = BOOTSTRAP_STEP_LABEL[bootstrapStep];
        return (_jsxs("div", { className: "TxnBootstrapLoader", role: "status", "aria-live": "polite", children: [_jsx("h3", { className: "TxnBootstrapLoader__title", children: "Preparing transaction" }), _jsx("div", { className: "TxnBootstrapLoader__progress", role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": progressValue, "aria-valuetext": "".concat(progressLabel, " (").concat(progressValue, "%)"), "aria-label": "Transaction setup progress", children: _jsx("div", { className: "TxnBootstrapLoader__progress-fill", style: { width: "".concat(progressValue, "%") } }) })] }));
    }
    return _jsx("div", { className: "PageTransition", children: children(info) });
}
